
import { computed, ComputedRef, defineComponent, inject } from 'vue';
import IconLogout from '@/components/common/icons/IconLogout.vue';
import routeNames from '@/router/routeNames';
import { useRouter } from 'vue-router';
import { AuthService, AuthServiceKey } from '@/services/auth';

export default defineComponent({
  name: 'LogoutButton',
  components: {
    IconLogout,
  },
  setup() {
    const router = useRouter();
    const auth: AuthService | undefined = inject(AuthServiceKey);

    if (!auth) {
      throw new Error('Could not resolve auth service.');
    }

    const isVisibleLogoutButton: ComputedRef<boolean> = computed(
      () => (auth?.isAuthenticated.value ?? false) && router.currentRoute.value.name !== routeNames.LOGOUT,
    );

    return { routeNames, isVisibleLogoutButton };
  },
});
